export default __webpack_public_path__ + "static/media/4a.45e94a08.jpg";